import { IoClose } from "react-icons/io5"
import { DrawerClose } from "@mylaunch/components/ui"
import { Media } from "~/components/ui/media"

interface DrawerCoverProps {
  imageUrl: string
  mimeType: string
  posterUrl?: string
}

export function DrawerCover({ imageUrl, mimeType, posterUrl }: DrawerCoverProps) {
  return (
    <div className="relative">
      <Media url={imageUrl} mimeType={mimeType} posterUrl={posterUrl} className="max-h-50 w-full rounded-t-xl object-cover" />
      <DrawerClose className="absolute top-s right-s z-10 rounded-full p-xs text-white outline-none">
        <div className="rounded-full bg-black/50 p-xs">
          <IoClose className="size-m" />
        </div>
      </DrawerClose>
    </div>
  )
}
